import { useAtomValue } from '@/utils/jotai-svelte';
import { onMountWithCore, teoAtom, teoCoreAtom } from '@/utils/teo-context';

const DynamicConfig$ = teoCoreAtom((core) => core.dynamicConfig);
// DynamicConfig$.onMount = onMountWithCore(({ refresh }, core) => {
//   return core.events.addEventListener('dynamicConfigChanged', refresh);
// });

const TextGeneratorEnabled$ = teoAtom((get) => get(DynamicConfig$).options.textGeneratorEnabled);
TextGeneratorEnabled$.onMount = onMountWithCore(({ refresh }, core) => {
  return core.dynamicConfig.addEventListener('textGeneratorEnabled', refresh);
});

export const useIsTextGeneratorEnabled = () => useAtomValue(TextGeneratorEnabled$);
